export const specStates = {
    CREATED: 1,
    DRAFT: 2,
    AVAILABLE: 3,
    IN_USE: 4,
};
